import * as ko from "knockout";
import {TBaseOrObservableType} from "../../../index";
import showmoreHtml from './showmore.html?raw';

export const template = showmoreHtml;

interface IParams {
    list: TBaseOrObservableType<any>
    num: KnockoutObservable<number>
}

export class viewModel {
    private readonly Default: number
    private readonly num: KnockoutObservable<number>
    constructor(private params: IParams) {
        this.Default = params.num()
        this.num = params.num
    }

    private max = ko.pureComputed((): number => {
        return ko.unwrap(this.params.list).length
    })
}
